import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import Langs, { Localize } from "../../app/lang/langs";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import { useDispatch } from "react-redux";
import { updateCollabSuiviStatus, updateWeeklyReview } from "../../components/collabs/collabsSlice";
import { getCollabMissions } from "../../components/teams/teamsSlice";

export function WeeklyFollowupTable(props) {

    const dispatch = useDispatch()

    const [selectedRow, setSelectedRow] = useState(props.selected)
    const [popupVisible, setPopupVisible] = useState(false)
    const [errors, setErrors] = useState([])

    const statusBodyTemplate = (rowData) => {
        const severity = rowData.status === "DONE" ? "success" : "warning"
        return <Tag value={Localize(rowData.status)} severity={severity} />
    }

    const typeBodyTemplate = (rowData) => {
        return <Langs str={rowData.type} />
    }

    const handleRowClick = (rowData) => {
        if (rowData) {
            setSelectedRow(rowData.data)
            setPopupVisible(true)
        }
    }

    const handleSave = () => {
        let errors = []
        if (!selectedRow.comments) {
            errors.push("comments")
        }
        setErrors(errors)

        if (!errors.length) {
            dispatch(updateWeeklyReview({
                id: selectedRow.id,
                comments: selectedRow.comments,
                id_collab: selectedRow.id_collab
            })).then(() => {
                dispatch(getCollabMissions({ id_collab: selectedRow.id_collab })).then((response) => {
                    const responseData = response.payload.responseData
                    if (responseData && responseData.followups && responseData.followups[0]) {
                        dispatch(updateCollabSuiviStatus(responseData.followups[0]))
                    }
                })
                setPopupVisible(false)
                setSelectedRow(null)
            })
        }
    }

    const handleChange = (e) => {
        setErrors([])
        let name = e.target.name
        let value = e.target.value
        setSelectedRow((prev) => ({ ...prev, [name]: value }))
    }

    return (
        <div className="card">
            {/* Tableau des suivis */}
            <DataTable value={props.data} dataKey="id"
                selectionMode="single"
                onRowClick={handleRowClick}>
                <Column field="week" header="Semaine" style={{ minWidth: '8rem' }} body={d=>parseInt(d.week)+1} />
                <Column field="client" header="Client" style={{ minWidth: '8rem' }} />
                <Column body={typeBodyTemplate} header="Suivis" style={{ minWidth: '14rem' }} />
                <Column
                    header="Status"
                    body={statusBodyTemplate}
                    style={{ minWidth: '8rem' }}
                />
                <Column field="createdBy" header={Localize("Suivi par")} style={{ minWidth: '8rem' }} />
            </DataTable>

            {/* POPUP */}
            <Dialog
                header={`${Localize(selectedRow?.type)} - Semaine ${parseInt(selectedRow?.week)+1}`}
                visible={popupVisible}
                style={{ width: "40rem" }}
                onHide={() => setPopupVisible(false)}
            >
                <div className="flex flex-column gap-4">
                    <InputTextarea
                        className={"w-full mb-2 " + (errors.includes("comments") ? "error" : "")}
                        name={"comments"}
                        rows={10}
                        autoResize
                        value={selectedRow?.comments}
                        onChange={handleChange}
                        error={errors.includes("comments")}
                    />
                    <Row className="d-flex justify-content-center align-items-center p-1 pb-2">
                        <Col md={5}>
                            <strong>
                                <Langs str="Suivi par" />
                            </strong>
                        </Col>
                        <Col md={7}>
                            <span>{selectedRow?.createdBy}</span>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-center align-items-center p-1 pb-2">
                        <Col md={5}>
                            <strong>
                                <Langs str="updated_by" />
                            </strong>
                        </Col>
                        <Col md={7}>
                            <span>{selectedRow?.updatedBy}</span>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-center align-items-center p-1 pb-2 mb-3">
                        <Col md={5}>
                            <strong>
                                <Langs str="updated_at" />
                            </strong>
                        </Col>
                        <Col md={7}>
                            <span>{selectedRow?.updated_at && moment(selectedRow?.updated_at).format("DD-MM-YYYY HH:mm")}</span>
                        </Col>
                    </Row>
                    <DynamicButton
                        onClick={handleSave}
                        className='me-auto'
                        title={<Langs str="Save" />}
                        active={true}
                        color="green"
                    />
                </div>
            </Dialog>
        </div>
    )
}